module.exports = __webpack_public_path__ + "static/media/b2.b99508e9.png";